export default __webpack_public_path__ + "static/blur-4-9d5858da0e87b912c10aefea53388481.svg";